export const convertBytesToMB = (bytes: number) => bytes / 1024 / 1024;
